import LiComponent from "./components/li";
import SpecOrderTileComponent from "./components/spec-order-tile";
import {initPage} from "./init-page";
import {renderProductsPage} from "./init-products-page";
import {setItemAdd} from "./require/set-item-add";
import {remove, render, RenderPosition} from "./utils/render";
import {showErrorModal} from "./utils/show-error-modal";
// import { showRespectModal } from "./utils/show-respect-modal";

const renderSpec = () => {
  const container = document.querySelector(`.items--tile`);

  const liItemComponent = new LiComponent({
    className: `item__itemWrap`,
  });
  render(container, liItemComponent.getElement(), RenderPosition.AFTERBEGIN);

  const productCardComponent = new SpecOrderTileComponent();

  const onAddButtonClickHandler = (data, cb) => {
    setItemAdd({
      title: data.title,
      buy: data.buy,
      sell: data.sell,
      link: data.link,
      date: data.date,
      groupId: catalogList.current,
      shopId: shopInfoData.shop_id,
      resolveHandler: () => {
        window.open(`/cart`, `_self`);
        // showRespectModal(`Параметры спецзаказа успешно отправлены!`);
        cb();
        remove(productCardComponent);
        remove(liItemComponent);
      },
      rejectHanlder: (textError) => {
        cb();
        showErrorModal(textError);
      },
    });
  };

  productCardComponent.setAddButtonClickHandler(onAddButtonClickHandler);


  render(liItemComponent.getElement(), productCardComponent.getElement(), RenderPosition.BEFOREEND);
};

window.addEventListener(`load`, () => {
  const pageName = window.location.pathname.slice(1);

  const onSpecButtonClickHandler = () => {
    if (document.querySelector(`.orderSpec`)) {
      return;
    }
    renderSpec();
  };

  initPage({pageName, onSpecButtonClickHandler});

  renderProductsPage(pageName, shopInfoData, filterList, itemList);

  if (shopInfoData.show_spec) {
    renderSpec();
  }
});
